﻿import { getTranslations } from "../../translations";
import { numberSelect, numberSelectEvent } from "../numberSelect";
import { addToCartEcom, removeFromCartEcom, trackBasketPopUpClick } from "../ecommerce/shoppingcart";
import { showNotification } from "../../utilities/notification";
import { sendDataLayer } from "../ecommerce/ecommerce";
import { Popup, PopupButton, PopupPosition } from "../../utilities/popup";
import { emptyCart, loadCart } from "./cartpopup";
import { progressSpinner, spinnerType } from "../../utilities/progressSpinner";

declare const Cookies: any;

let activeCall = null;

document.addEventListener("DOMContentLoaded", () =>
{
    document.querySelectorAll(".js-input-select").forEach((input: HTMLInputElement) =>
    {
        const select = new numberSelect(input, modifyCartQuantity);
    });

    $("#priceForm").on("keydown", (e) =>
    {
        if (e.key == "Enter")
        {
            e.preventDefault();
            return false;
        }
    });

    $("#priceForm").on("submit", (e) =>
    {
        if ($("[name=nextStep]").length == 0)
        {
            e.preventDefault();
            e.stopPropagation();
            if (activeCall !== null)
                return false;
            else
            {
                var form = $("#priceForm");
                var nextStep = $("<input type='hidden'></input>");
                nextStep.attr("name", "nextStep");
                nextStep.val("1");

                form.append(nextStep);
                form.trigger('submit');
            }
        }
    });

    checkWarningNotification(null, event);
    removeUnnecessaryProperty(document);
    addRelatedArticlesEvents();
});

declare const items: any;
declare const getCartAddArticleSummary: any;
declare const orgProductDetail: any;
let loadedCartPopup: boolean;

export const addArticleLocationToStash = (articleNumber, location) =>
{
    if (typeof (articleNumber) != typeof (undefined))
    {
        if (typeof (location) == typeof (undefined))
            location = location.pathname;

        var expirationDate = new Date();
        expirationDate.setMonth(expirationDate.getMonth() + 1);

        var currentValue = Cookies.get(articleNumber);
        if (currentValue != null && typeof (currentValue) != typeof (undefined))
            Cookies.set(articleNumber, currentValue + ',' + location, { path: '/', expires: expirationDate })
        else
            Cookies.set(articleNumber, location, { path: '/', expires: expirationDate })
    }
};

let interval;

export const addArticleToCart = (source, aid, async, getproduct, ignoreCartPopup, showCartAddSummary, showInCartNotification: boolean = true, createTemplate: boolean = false) =>
{
    if (source != undefined && source != null && $(source).attr("class").indexOf("disabled") >= 0)
        return false;

    if (!ignoreCartPopup)
    {
        var smulCode = '';

        if (typeof (undefined) != typeof (items))
            smulCode = items['item_smulcode'];
        else
        {
            var $source = $(source).closest(".favorite-list-content-element");
            if ($source.length > 0)
            {
                smulCode = $($source[0]).data("smulcode");
                if (typeof (undefined) == typeof (smulCode))
                    smulCode = $($source[0]).data("articlenumber");
            }
        }

        addArticleLocationToStash(smulCode, location.pathname);
    }

    if (interval != null)
        clearInterval(interval);

    var $form = $("form.product-detail");

    let productID = 0;

    if ($form.length > 0)
    {
        if ($form.children("input[name='shopid']").length > 0)
            productID = parseInt($form.children("input[name='shopid']").val().toString() ?? "0");
        else if ($form.children("input[name='relshopid']").length > 0)
            productID = parseInt($form.children("input[name='relshopid']").val().toString() ?? "0");
    }

    if (productID == 0 && $(source).data("productid") !== undefined)
        productID = parseInt($(source).data("productid"));

    //Default variables
    var ajaxURL = "/Services/Modules/Webshop.asmx/AddArticleToCart";
    var ajaxPostData = "{valuelist: [], articleid: " + aid + ", productid: " + productID + ", quantity: 1 }";
    var returnProduct = false;
    var returnOrderLine = false;

    if (async)
    {
        // Return detail template
        if (typeof getproduct !== typeof (undefined) && getproduct)
            returnProduct = true;

        // Return orderline template when add articles on the cart page
        if ($('.shopingcart').length > 0)
        {
            returnOrderLine = true;
            productID = $('.combibundles').data('pid');

            if (
                $(source).parent().length > 0 &&
                typeof ($(source).parent().data("pid")) != typeof (undefined)
            )
                productID = $(source).parent().data("pid");
        }

        if (productID === 0 && $(source).closest(".featureditem"))
            productID = $(source).closest(".featureditem ").data("productid");

        if (typeof (productID) === typeof (undefined))
            productID = 0;

        ajaxURL = "/Services/Modules/Webshop.asmx/AddArticleToCartExtended";
        ajaxPostData = "{valuelist: [], articleid: " + aid + ", productid: " + productID + ", quantity: 1, returnProduct: " + returnProduct + ",  returnOrderLine: " + returnOrderLine + " }";

        $(".button-pay, .cart-popup-pay").addClass("disabled");
        $(".btn.button-pay").addClass('btn-loading-spinner');
        if ($(source).hasClass("loader-button"))
            $(source).addClass("btn-loading-spinner");
        $(source).find(".loader-button").addClass("btn-loading-spinner");
    }

    $.ajax({
        type: "POST",
        url: ajaxURL,
        data: ajaxPostData,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        error: function (jqXHR, textStatus, errorThrown)
        {
            console.log(jqXHR);
            console.log(textStatus);
            console.log(errorThrown);
        },
        success: function (data)
        {
            if (ignoreCartPopup && showInCartNotification)
            {
                showNotification({ message: getTranslations().cartHeaderText });
                loadCart();
            }
            else
            {
                var productdetail = data.d.ProductDetail;
                var orderLine = data.d.OrderLine;
                var errors = data.d.Error;
                var warnings = data.d.Warning;
                var remainingAmountForFreeShipping = data.d.RemainingAmountForFreeShipping;

                var deliveryTextElement = $(".product-detail .stock-status .delivery");
                if (deliveryTextElement.length > 0 && typeof (undefined) != typeof (remainingAmountForFreeShipping))
                {
                    if (remainingAmountForFreeShipping <= 0)
                        $(deliveryTextElement).addClass('free-shipping');
                    else
                        $(deliveryTextElement).removeClass('free-shipping');
                }

                if (showCartAddSummary &&
                    $("#wrapper").hasClass("cart-article-summary") &&
                    typeof (getCartAddArticleSummary) === "function"
                )
                    getCartAddArticleSummary(aid, productID, 1);
                else if (!ignoreCartPopup)
                {
                    if (createTemplate && productdetail)
                    {
                        let productTemplate = document.querySelector("#cart-template");

                        if (!productTemplate)
                            productTemplate = document.createElement("template");

                        productTemplate.setAttribute("id", "cart-template");
                        productTemplate.innerHTML = productdetail;
                        document.querySelector("main").append(productTemplate);
                    }

                    const buttons = [];

                    const btnClose = new PopupButton();
                    btnClose.className = "btn btn-arrow-left btn-blue show-desktop g-popup__button--margin-right";
                    btnClose.label = getTranslations().txtContinueShopping;
                    btnClose.closeOnCLick = true;
                    btnClose.onClick = () =>
                    {
                        trackBasketPopUpClick('Verder winkelen');
                    };
                    buttons.push(btnClose);

                    const btnCloseMobile = new PopupButton();
                    btnCloseMobile.className = "btn btn-arrow-right btn-blue-link show-mobile";
                    btnCloseMobile.label = getTranslations().txtContinueShopping;
                    btnCloseMobile.closeOnCLick = true;
                    btnCloseMobile.onClick = () =>
                    {
                        trackBasketPopUpClick('Verder winkelen');
                    };
                    buttons.push(btnCloseMobile);

                    const btnCart = new PopupButton();
                    btnCart.className = "btn btn-green full-width";
                    btnCart.label = getTranslations().txtLookAtShoppingCart;
                    btnCart.onClick = () =>
                    {
                        trackBasketPopUpClick('Naar winkelwagen');
                        location.href = getTranslations().shoppingCartUrlLowerCaseTxt;
                        const pdpLoader = new progressSpinner(".w-main", spinnerType.smulders);
                        pdpLoader.show(true);
                        return;
                    };
                    buttons.push(btnCart);

                    const addToCartPopup = new Popup({
                        id: "add-to-cart-popup",
                        popupClass: "g-popup__footer-buttons--add-to-cart",
                        title: getTranslations().cartHeaderText,
                        desktopPosition: PopupPosition.CenterSmall,
                        mobilePosition: PopupPosition.Drawer,
                        content: document.getElementById("cart-template").innerHTML,
                        headerIcon: "ic-check-aft cl-gd2-aft-bg",
                        closeButton: true,
                        buttons: buttons
                    });

                    addToCartPopup.show();

                    if (returnOrderLine)
                    {
                        var orderID = $(orderLine).filter('.order').data('id');
                        if (typeof (orderID) != typeof (undefined))
                        {
                            if ($('.orders').find(`[data-id='${orderID}']`).length > 0)
                            {
                                orderID = orderID.substring(0, orderID.lastIndexOf('_'));
                                var curOrder = $('.orders').find(`[data-id^='${orderID}']`);
                                $(curOrder).find("input").val(parseInt($(curOrder).find("input").val()) + 1);
                            }
                            else
                            {
                                $('.orders .order:not(.discount-row)').last().after(orderLine);
                            }
                        }
                    }

                    if (typeof errors !== typeof (undefined) && errors != null && errors.length > 0)
                        $("#product-to-cart-popup .cart-popup-error").html(errors);
                    else
                        $("#product-to-cart-popup .cart-popup-error").empty();

                    if (typeof warnings !== typeof (undefined) && warnings != null && warnings.length > 0)
                        $("#product-to-cart-popup .cart-popup-warning").html(warnings);
                    else
                        $("#product-to-cart-popup .cart-popup-warning").empty();
                }
            }

            var cart = data.d.Cart;

            loadedCartPopup = false;

            // Set the HTML for the cart.
            if (cart != null)
            {
                $(".js-header-cart").replaceWith(cart);
                $(".js-header-cart").css("opacity", "0.1");
            }

            var counter = 0;
            interval = setInterval(function ()
            {
                counter++;

                $(".js-header-cart").css("opacity", (0.1 * counter));
                if (counter == 9)
                {
                    $(".js-header-cart").removeAttr("style");
                    clearInterval(interval);
                }
            }, 50);
        },
        complete: function ()
        {
            if (async == undefined || async == false)
                document.location.href = getTranslations().shoppingCartUrlLowerCaseTxt;
            else
            {
                // TODO hideLoaderIcon
                //hideLoaderIcon(source);
            }
            // TODO init cartpopup
            //initCartPopUp(true, false);

            $(".button-pay, .cart-popup-pay").removeClass("disabled");
            $(".btn.button-pay").removeClass('btn-loading-spinner');
            $(source).removeClass("btn-loading-spinner");
            $(source).find(".loader-button").removeClass("btn-loading-spinner");
        }
    });

    return false;
};

export const addArticleToCartAnimation = (source, selector, isParent) =>
{
    // No selector set.
    if (typeof (selector) === typeof (undefined) || selector == null || selector.length <= 0)
        return false;

    // Can't find cart or image.
    if ($(".header-cart-holder.add-cart-animation .js-header-cart").length <= 0 || $(selector).length <= 0)
        return false;

    // Check if a parent selector was given, or the direct image path itself.
    if (!isParent)
        isParent = false;

    var parentSelector = selector;
    var parentHeight = null;
    var parentWidth = null;
    var parentActiveElementOffset = null;

    if (isParent)
    {
        // Store parent height/width.
        parentHeight = $(parentSelector).outerHeight(false);
        parentWidth = $(parentSelector).outerWidth(false);

        // Store offset of active parent element.
        if ($(selector + " .uk-active").length > 0)
            parentActiveElementOffset = $(selector + " .uk-active").offset();

        if ($(selector + " .uk-active img:visible").length > 0)
            selector = $(selector + " .uk-active img:visible")[0];
        else if ($(selector + " img:visible").length > 0)
            selector = $(selector + " img:visible")[0];
        else if ($(selector + " img").length > 0)
            selector = $(selector + " img")[0];
        else
            // Return if no image found at all.
            return false;
    }

    // Get original image dimensions and offsets.
    var imageHeight = $(selector).outerHeight(false);
    var imageWidth = $(selector).outerWidth(false);
    var imageOffset = $(selector).offset();

    // Fallback to parent dimensions in case image dimensions weren't set (i.e. PDP video is active slide).
    if (parentHeight != null && parentWidth != null &&
        parentHeight > 0 && parentWidth > 0)
    {
        if (typeof (imageHeight) === typeof (undefined) || imageHeight == null || imageHeight <= 0 ||
            typeof (imageWidth) === typeof (undefined) || imageWidth == null || imageWidth <= 0)
        {
            imageHeight = parentHeight;
            imageWidth = parentWidth;
        }
    }

    // Fallback to parent active element offset in case image offset wasn't set (i.e. PDP video is active slide).
    if (parentActiveElementOffset != null &&
        parentActiveElementOffset.top > 0 && parentActiveElementOffset.left > 0 &&
        imageOffset.top <= 0 && imageOffset.left <= 0)
        imageOffset = parentActiveElementOffset;

    // Get cart dimensions and offsets.
    var cartHeight = $(".js-header-cart").outerHeight(false);
    var cartWidth = $(".js-header-cart").outerWidth(false);
    var cartOffset = $(".js-header-cart").offset();

    // Set dimensions the cloned image will have at the end of its animation.
    var resultHeight = cartHeight;
    var resultWidth = cartWidth;

    // Get size ratio differences between image and cart.
    var resultHeightRatio = cartHeight / imageHeight;
    var resultWidthRatio = cartWidth / imageWidth;

    // Ensure the right aspect ratio is preserved, by setting one dimension based on the other dimension's
    // change ratio. (I.e. 600x300 image moving to 40x40 cart results in image gradually becoming 40x20.)
    if (resultHeightRatio > resultWidthRatio)
        resultHeight = imageHeight * resultWidthRatio;
    else
        resultWidth = imageWidth * resultHeightRatio;

    // Create cloned item and set properties.
    var clonedItem = $(selector).clone();
    $(clonedItem).css("position", "absolute");
    $(clonedItem).css("top", imageOffset.top);
    $(clonedItem).css("left", imageOffset.left);
    $(clonedItem).height(imageHeight);
    $(clonedItem).width(imageWidth);
    $(clonedItem).css("z-index", "999999");

    // Append cloned item to body.
    $(clonedItem).appendTo("body");

    // Set image offset such that its exact center will be the center of the shopping cart.
    var topOffset = cartOffset.top + ((cartHeight - resultHeight) / 2);
    var leftOffset = cartOffset.left + ((cartWidth - resultWidth) / 2);

    // Move image to cart and shrink it gradually.
    $(clonedItem).animate({
        top: topOffset,
        left: leftOffset,
        height: resultHeight,
        width: resultWidth
    }, 500, function ()
    {
        // Remove image when it reached the end.
        $(clonedItem).remove();
    });
}

export const modifyCartQuantity = (e: CustomEvent<numberSelectEvent>) =>
{
    if (e?.detail)
    {
        const originalEvent: Event | null = e.detail.originalEvent;
        if (originalEvent)
        {
            const oldValue = e.detail.oldValue;
            const newValue = e.detail.value;
            const orderLine = $(originalEvent.target).closest(".js-order-line");
            const articleID = $(orderLine).data("articleid");

            const isPopup = $(orderLine).closest(".shoppingcart").length > 0;

            if (newValue < oldValue)
                removeFromCartEcom(orderLine[0], (oldValue - newValue));
            else
                addToCartEcom(orderLine[0], (oldValue - newValue));

            updateCartQuantity(articleID, newValue, orderLine[0], isPopup);
        }
    }
}

export const deleteOrderLine = (source) =>
{
    var articleID = $(source).closest(".js-order-line").data("articleid");
    if (typeof (undefined) == typeof (articleID))
        articleID = $(source).data("articleid");

    updateCartQuantity(articleID, 0, $(source).closest(".js-order-line")[0], false);
}

const updateBundleArticle = (articleID: number, value: number) =>
{
    if (!document.getElementById("modal-pdp-bundle"))
        return;

    const articleElementPopup = $(`div[data-aid=${articleID}]`);
    articleElementPopup.find(".c-product-spec__quantity").val(value);

    if (value >= 1)
        return;

    articleElementPopup.find(".c-product-spec__amountcontainer").addClass("hidden");
    articleElementPopup.find(".c-product-spec__addbutton").removeClass("hidden");
    articleElementPopup.find(".c-product-spec__addbutton").show();

    if (!document.querySelector(".c-product-spec__button-container"))
        return;

    $(".c-product-spec__button-container").find("span").text($(".c-product-spec__button-container").attr("data-title"));
}

// Update value
export const updateCartQuantity = (articleID: number, newValue: number, orderLine: HTMLElement, isPopup: boolean) =>
{
    updateBundleArticle(articleID, newValue);

    // Update
    if (newValue > 0)
    {
        let activeCall = $.ajax({
            type: "POST",
            url: "/Services/Modules/Webshop.asmx/ModifyCartArticle?ajax=1&article=" + articleID + "&amount=" + newValue,
            data: "{}",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (data)
            {
                if (data?.d?.ProductList)
                {
                    const product = data.d.ProductList[0];

                    // Handle errors
                    if (product.CartError?.length > 0)
                        handleCartError(product.CartError);

                    // Update popup content   
                    updateOrderLine($(`.js-order-line[data-articleid=${articleID}]`), product);

                    // Update discount
                    if (product.TotalDiscount !== "" && parseInt(product.TotalDiscount) > 0)
                        updateDiscountLine(product.Discount);
                    else
                        removeDiscountLine();

                    // Update summary
                    updateCartSummary(product);

                    // Update header
                    if (product.Cart)
                        updateCartHeader(product.Cart);

                    // Update cartpopup
                    updateCartPopup(product.Cart);

                    // Update warning
                    updateWarning(product.OverviewStatus);

                    // Update article delivery message
                    {
                        let deliveryMessageItem = null;

                        if ($(product.ArticleStatus).filter(".spec-content").length > 0)
                            deliveryMessageItem = $(product.ArticleStatus).filter(".spec-content")[0];
                        else if ($(product.ArticleStatus).filter(".availability").length > 0)
                            deliveryMessageItem = $(product.ArticleStatus).filter(".availability")[0];
                        else
                            deliveryMessageItem = $(product.ArticleStatus).filter(".u-stockmessage")[0];

                        updateCartDeliveryMessage(articleID, deliveryMessageItem);
                    }

                    const freeArticleIDs = [];
                    $(".js-order-line").each(function (index, item)
                    {
                        if ($(item).find(".js-free-quantity").length > 0)
                            freeArticleIDs.push($(item).data("articleid"));
                    });

                    if (data.d.FreeArticles)
                    {
                        data.d.FreeArticles.forEach(function (item)
                        {
                            if (item)
                            {
                                const article = $(`.js-order-line[data-articleid='${item.ArticleID}']`);

                                if (article.length > 0)
                                {
                                    if (item.Quantity <= 0)
                                    {
                                        $(article).slideUp(450, function ()
                                        {
                                            $(this).remove();
                                        });
                                    }
                                    else
                                    {
                                        if (freeArticleIDs.indexOf(item.ArticleID) >= 0)
                                            freeArticleIDs.splice(freeArticleIDs.indexOf(item.ArticleID), 1);

                                        const articleQuantity = article.find(".js-free-quantity");
                                        articleQuantity.text(`${item.Quantity}x`);
                                    }
                                }
                            }
                        });
                    }

                    freeArticleIDs.forEach(function (freeArticleID)
                    {
                        const article = $(`.js-order-line[data-articleid='${freeArticleID}']`);

                        if (article.length > 0)
                        {
                            $(article).slideUp(450, function ()
                            {
                                $(this).remove();
                            });
                        }
                    });
                }
            },
            complete: function ()
            {
                activeCall = null;
            }
        });
    }
    else
    {
        const articleCount = $(".js-order-line").length;

        // remove article from overview
        $(orderLine).slideUp(450, function ()
        {
            $(this).remove();
        });

        let activeCall = $.ajax({
            type: "POST",
            url: "/Services/Modules/Webshop.asmx/ModifyCartArticle?ajax=1&article=" + articleID + "&amount=" + 0,
            data: "{}",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (data)
            {
                if (data?.d?.ProductList)
                {
                    const product = data.d.ProductList[0];

                    // Handle errors
                    if (product.CartError?.length > 0)
                        handleCartError(product.CartError);

                    // Update summary
                    updateCartSummary(product);

                    // Update header
                    if (product.TotalDiscount !== "" && parseInt(product.TotalDiscount) > 0)
                        updateDiscountLine(product.Discount);
                    else
                        removeDiscountLine();

                    // Update header
                    if (product.Cart)
                        updateCartHeader(product.Cart);

                    // Update cartpopup
                    updateCartPopup(product.Cart);

                    const freeArticleIDs = [];
                    $(".js-order-line").each(function (index, item)
                    {
                        if ($(item).find(".js-free-quantity").length > 0)
                            freeArticleIDs.push($(item).data("articleid"));
                    });

                    if (data.d.FreeArticles)
                    {
                        data.d.FreeArticles.forEach(function (item)
                        {
                            if (item)
                            {
                                const article = $(`.js-order-line[data-articleid='${item.ArticleID}']`);

                                if (article.length > 0)
                                {
                                    if (item.Quantity <= 0)
                                    {
                                        $(article).slideUp(450, function ()
                                        {
                                            $(this).remove();
                                        });
                                    }
                                    else
                                    {
                                        if (freeArticleIDs.indexOf(item.ArticleID) >= 0)
                                            freeArticleIDs.splice(freeArticleIDs.indexOf(item.ArticleID), 1);

                                        const articleQuantity = article.find(".js-free-quantity");
                                        articleQuantity.text(`${item.Quantity}x`);
                                    }
                                }
                            }
                        });
                    }

                    freeArticleIDs.forEach(function (freeArticleID)
                    {
                        const article = $(`.js-order-line[data-articleid='${freeArticleID}']`);

                        if (article.length > 0)
                        {
                            $(article).slideUp(450, function ()
                            {
                                $(this).remove();
                            });
                        }
                    });
                }
            },
            complete: function ()
            {
                activeCall = null;

                if (articleCount <= 1)
                    $("#priceForm").trigger('submit');
            }
        });
    }
};

const updateWarning = (element?: string) =>
{
    if (element === null || element === undefined)
        return;

    const $element = $(element);

    const $existingWarning = $(`#${$element.attr("id")}`);

    // Add new warning, or update existing one.
    if ($existingWarning.length <= 0)
        $(".u-container-sidebar__section").prepend(element);
    else
    {
        $existingWarning.removeClass("hidden");
        $existingWarning.html($element.html());
    }
}

const updateCartDeliveryMessage = (articleID: number, element?: HTMLElement) =>
{
    if (element === null || element === undefined)
        return;

    const $article = $(`[data-articleid='${articleID}']`);
    let $existingDeliveryText = null;

    if ($article.find(".spec-content").length > 0)
        $existingDeliveryText = $article.find(".spec-content")[0];
    else if ($article.find(".availability").length > 0)
        $existingDeliveryText = $article.find(".availability")[0];
    else if ($article.find(`.u-stockmessage:not(.u-stockmessage--warning)`).length > 0)
        $existingDeliveryText = $article.find(`.u-stockmessage:not(.u-stockmessage--warning)`);

    if ($existingDeliveryText.length > 0)
        $existingDeliveryText.replaceWith(element);
}

const updateCartHeader = (cart: HTMLElement) =>
{
    if (cart)
    {
        $(".js-header-cart").fadeOut(() =>
        {
            $(".js-header-cart").replaceWith(cart);
            $(".js-header-cart").fadeIn();
        });
    }
};

const updateCartPopup = (cart?: HTMLElement) =>
{
    if ($(cart).find(".js-header-cart-counter").length === 0)
    {
        setTimeout(() =>
        {
            emptyCart();
        }, 200);
    }
}

const updateOrderLine = (article: JQuery<HTMLElement>, articleData: any) =>
{
    // Update article price
    if (document.documentElement.lang == "NL")
    {
        if (articleData.ArticleOldPrice.trim() != "0,00" && articleData.ArticleOldPrice.trim() != "0,-" && articleData.ArticleOldPrice.trim() != "0")
        {
            $(article).find(".js-oldprice").html(articleData.ArticleOldPrice.replace(",00", ",-"));
            $(article).find(".js-currentprice").html(articleData.ArticlePrice.replace(",00", ",-"));
        }
        else
        {
            $(article).find(".js-oldprice").html("");
            $(article).find(".js-currentprice").html(articleData.ArticlePrice.replace(",00", ",-"));
        }
    }

    $(article).find(".js-input-select").val(articleData.ArticleQuantity);
}

const updateDiscountLine = (discount: any) =>
{
    if (discount && discount.length > 0)
    {
        if ($(".js-discount-row").length > 0)
        {
            $(".js-discount-row").replaceWith(discount);
        }
        else if (discount.indexOf("js-discount-row") > 0)
        {
            $(".js-order-lines").append(discount);
        }
    }
}

const removeDiscountLine = () =>
{
    const discountLine = document.querySelector(".js-discount-row");

    if (discountLine)
        discountLine.remove();
}

const updateCartSummary = (articleData: any) =>
{
    if (document.documentElement.lang == "NL")
    {
        $(".js-shipping-costs").text(articleData.ShippingCost);
        $(".js-total").text(articleData.TotalCost);
        $(".js-subtotal").text(articleData.TotalArticleCostNoBenefit);
    }
    else if (document.documentElement.lang == "FR")
    {
        articleData.ShippingCost = articleData.ShippingCost.replace(" ", "");
        articleData.TotalCost = articleData.TotalCost.replace(" ", "");
        articleData.TotalArticleCostNoBenefit = articleData.TotalArticleCostNoBenefit.replace(" ", "");

        const euroSignHtml = '&nbsp;<span class="currencySign">&euro;</span>';
        if (isNaN(articleData.ShippingCost.trim().replace(",", ".")))
            $(".js-shipping-costs").html(articleData.ShippingCost);
        else
            $(".js-shipping-costs").html(articleData.ShippingCost + "&nbsp;<span class=\"currencySign\">&euro;</span>");

        $(".js-total").html(articleData.TotalCost + "&nbsp;<span class=\"currencySign\">&euro;</span>");
        $(".js-subtotal").html(articleData.TotalArticleCostNoBenefit.trim() + "&nbsp;&euro;");
    }

    // Check if price contains a decimal value
    var hasNumber = /\d/;
    if (!hasNumber.test(articleData.ShippingCost))
        $(".js-shipping-costs").addClass("no_costs");
    else
        $(".js-shipping-costs").removeClass("no_costs");

    if (articleData?.TotalBenefit?.length > 0)
    {
        $(".js-benefitamount").text(articleData.TotalBenefit.trim());
        $(".js-benefitamount").parent().removeClass("hidden");
    }
    else
        $(".js-benefitamount").parent().addClass("hidden");
};

const handleCartError = (cartError: string) =>
{
    const errorHtml = cartError;
    let errors = [];

    if (errorHtml.indexOf("<br>") > 0)
        errors = errorHtml.split("<br>");
    else if (errorHtml.indexOf("<br />") > 0)
        errors = errorHtml.split("<br />");
    else
    {
        var partText = $(errorHtml).text().trim();

        if (partText.length == 0)
            partText = errorHtml.trim();

        errors.push(partText);
    }

    $(errors).each(function ()
    {
        if (this != null && this != "")
        {
            sendDataLayer({
                'event': 'Klantenmededelingen',
                'category': 'Klantenmededelingen',
                'action': document.location.pathname,
                'label': this.toString()
            });
        }
    });

    showNotification({ message: cartError, status: "danger", position: "top-right", timeout: 5000 });
};

const notificationKey = "deliveryWarningNotificationClosed";

function closeWarningNotification(e: JQuery, event?: Event): void
{
    if (event)
        event.preventDefault();

    sessionStorage[notificationKey] = "1";

    const statusWarning = document.querySelector(".status-warning");
    if (statusWarning)
        statusWarning.classList.add("hidden");
}

function checkWarningNotification(e: JQuery, event?: Event): void
{
    if (event)
        event.preventDefault();

    if (sessionStorage[notificationKey] === "1")
        closeWarningNotification(e, event);
}

(window as any).deleteOrderLine = deleteOrderLine;
(window as any).addArticleToCart = addArticleToCart;
(window as any).addArticleToCartAnimation = addArticleToCartAnimation;
(window as any).closeWarningNotification = closeWarningNotification;

const removeErrorMessage = (element: HTMLElement) =>
{
    const productList = document.querySelectorAll(".w-productlist__card");

    if (productList.length === 0)
        window.location.reload();
}

(window as any).removeErrorMessage = removeErrorMessage;

export const removeUnnecessaryProperty = (element: HTMLElement | Document) =>
{
    const products = element.querySelectorAll(".js-order-line");

    if (!products)
        return;

    products.forEach((product: HTMLElement) =>
    {
        if (getTranslations().notAllowedForColors.includes(product.dataset.category))
        {
            const productColorElement = product.querySelector(".kleur");

            if (!productColorElement)
                return;

            productColorElement.remove();
        }
    })
}

(window as any).removeUnnecessaryProperty = removeUnnecessaryProperty;

function addRelatedArticlesEvents()
{
    if (!(window as any).initRelatedArticleEvents)
    {
        (window as any).initRelatedArticleEvents = true;
        
        const customRelatedArticlesElement = ".c-cart-related-container";

        if ($(customRelatedArticlesElement).length > 0)
    {
        $(customRelatedArticlesElement).find(".cart-related-articles .w-productcard__holder").off("click").on("click", handleArticleItemClick);

        if ($(customRelatedArticlesElement).find(".cart-related-articles").length > 0)
        {
            $(customRelatedArticlesElement).find(".cart-related-articles .w-productcard__holder").each(function (index, item)
            {
                onScrolledIntoView($(item), function ()
                {
                    sendDataLayer({ ecommerce: null }); // Clear the previous ecommerce object.

                    var items = [];
                    var breadcrumbs = getBreadCrumbImpression();
                    var link = "";

                    $(item).each(function (index, element)
                    {
                        var combiItem = $(element);
                        link = combiItem.find("a").attr("href")
                        var name = combiItem.attr("data-name");
                        var sku = combiItem.attr("data-sku");
                        var price = combiItem.attr("data-price");
                        var discount = combiItem.attr("data-discount");
                        var brand = combiItem.attr("data-brand");
                        var category = combiItem.attr("data-category");
                        var color = combiItem.attr("data-color");
                        var variant = combiItem.attr("data-variant");
                        var size = combiItem.attr("data-size");
                        var livingstyle = combiItem.attr("data-livingstyle");
                        var priceclass = combiItem.attr("data-priceclass");
                        var position = combiItem.attr("data-position");
                        var material = combiItem.attr("data-material");
                        var stuffing = combiItem.attr("data-stuffing");
                        var season = combiItem.attr("data-season");
                        var deliverytime = combiItem.attr("data-deliverytime");
                        var articlenumber = combiItem.attr("data-articlenumber");
                        var sleepingposition = combiItem.attr("data-sleepingposition");
                        var firmness = combiItem.attr("data-firmness");
                        var stock = combiItem.attr("data-stock");
                        var type = combiItem.attr("data-type");
                        var thermalclass = combiItem.attr("data-thermalclass");

                        var item = {};
                        if (name != '')
                            item['item_name'] = name;
                        if (sku != '')
                            item['item_id'] = sku;
                        if (price != '')
                            item['price'] = price;
                        if (discount != '')
                            item['discount'] = discount;
                        item['currency'] = 'EUR';
                        if (brand != '')
                            item['item_brand'] = brand;
                        if (category != '')
                            item['item_category'] = category;
                        if (breadcrumbs['item3'] != '')
                            item['item_category2'] = breadcrumbs['item3'];
                        if (breadcrumbs['item4'] != '')
                            item['item_category3'] = breadcrumbs['item4'];
                        if (breadcrumbs['item5'] != '')
                            item['item_category4'] = breadcrumbs['item5'];
                        if (breadcrumbs['item6'] != '')
                            item['item_category5'] = breadcrumbs['item6'];
                        if (variant != '')
                            item['item_variant'] = variant;
                        if (color != '')
                            item['item_color'] = color;
                        if (size != '')
                            item['item_size'] = size;
                        if (livingstyle != '')
                            item['item_woonstijl'] = livingstyle;
                        if (priceclass != '')
                            item['item_prijsklasse'] = priceclass;
                        if (material != '')
                            item['item_materiaal'] = material;
                        if (stuffing != '')
                            item['item_vulling'] = stuffing;
                        if (season != '')
                            item['item_seizoen'] = season;
                        if (deliverytime != '')
                            item['item_levertijd'] = deliverytime;
                        if (articlenumber != '')
                            item['item_smulcode'] = articlenumber;
                        if (sleepingposition != '')
                            item['item_slaaphouding'] = sleepingposition;
                        if (firmness != '')
                            item['item_stevigheid'] = firmness;
                        if (stock != '')
                            item['item_voorraad'] = stock;
                        if (type != '')
                            item['item_type'] = type;
                        if (thermalclass != '')
                            item['item_warmteklasse'] = thermalclass;
                        item['item_list_id'] = '1';
                        item['item_list_name'] = 'Handig voor erbij';
                        if (position != '')
                            item['index'] = position;
                        item['quantity'] = '1';
                        item['google_business_vertical'] = 'retail';

                        items.push(item);
                    });

                    sendDataLayer({
                        'event': 'productView',
                        'category': 'Ecommerce',
                        'action': 'Handig voor erbij',
                        'label': link,
                        'ecommerce': {
                            'items': items
                        }
                    });
                });
            });
        }
        }
    }
}

function handleArticleItemClick() {
    if (!$.stash.exists("relatedArticleClickedItem") ||
        typeof ($.stash.get("relatedArticleClickedItem")) === typeof (undefined)
    )
    $.stash.set("relatedArticleClickedItem", $(this).attr("data-aid"));

    var breadcrumbs = getBreadCrumbImpression();
    var name = $(this).attr("data-name");
    var sku = $(this).attr("data-sku");
    var price = $(this).attr("data-price");
    var discount = $(this).attr("data-discount");
    var brand = $(this).attr("data-brand");
    var category = $(this).attr("data-category");
    var color = $(this).attr("data-color");
    var variant = $(this).attr("data-variant");
    var size = $(this).attr("data-size");
    var livingstyle = $(this).attr("data-livingstyle");
    var priceclass = $(this).attr("data-priceclass");
    var position = $(this).attr("data-position");
    var material = $(this).attr("data-material");
    var stuffing = $(this).attr("data-stuffing");
    var season = $(this).attr("data-season");
    var deliverytime = $(this).attr("data-deliverytime");
    var articlenumber = $(this).attr("data-articlenumber");
    var sleepingposition = $(this).attr("data-sleepingposition");
    var firmness = $(this).attr("data-firmness");
    var stock = $(this).attr("data-stock");
    var type = $(this).attr("data-type");
    var thermalclass = $(this).attr("data-thermalclass");

    var items = {};
    if (name != '')
        items['item_name'] = name;
    if (sku != '')
        items['item_id'] = sku;
    if (price != '')
        items['price'] = price;
    if (discount != '')
        items['discount'] = discount;
    items['currency'] = 'EUR';
    if (brand != '')
        items['item_brand'] = brand;
    if (category != '')
        items['item_category'] = category;
    if (breadcrumbs['item3'] != '')
        items['item_category2'] = breadcrumbs['item3'];
    if (breadcrumbs['item4'] != '')
        items['item_category3'] = breadcrumbs['item4'];
    if (breadcrumbs['item5'] != '')
        items['item_category4'] = breadcrumbs['item5'];
    if (breadcrumbs['item6'] != '')
        items['item_category5'] = breadcrumbs['item6'];
    if (variant != '')
        items['item_variant'] = variant;
    if (color != '')
        items['item_color'] = color;
    if (size != '')
        items['item_size'] = size;
    if (livingstyle != '')
        items['item_woonstijl'] = livingstyle;
    if (priceclass != '')
        items['item_prijsklasse'] = priceclass;
    if (material != '')
        items['item_materiaal'] = material;
    if (stuffing != '')
        items['item_vulling'] = stuffing;
    if (season != '')
        items['item_seizoen'] = season;
    if (deliverytime != '')
        items['item_levertijd'] = deliverytime;
    if (articlenumber != '')
        items['item_smulcode'] = articlenumber;
    if (sleepingposition != '')
        items['item_slaaphouding'] = sleepingposition;
    if (firmness != '')
        items['item_stevigheid'] = firmness;
    if (stock != '')
        items['item_voorraad'] = stock;
    if (type != '')
        items['item_type'] = type;
    if (thermalclass != '')
        items['item_warmteklasse'] = thermalclass;
    items['item_list_id'] = '1';
    items['item_list_name'] = 'Handig voor erbij';
    if (position != '')
        items['index'] = position;
    items['quantity'] = '1';
    items['google_business_vertical'] = 'retail';

    sendDataLayer({ ecommerce: null }); // Clear the previous ecommerce object.
    sendDataLayer({
        'event': 'productClick',
        'category': 'Ecommerce',
        'action': 'Handig voor erbij',
        'label': $(this).find("a").attr("href"),
        'ecommerce': {
            'items': [items]
        }
    });
}

function getBreadCrumbImpression()
{
    var breadcrumbholder = $('.breadcrumbs-holder div a');

    var breadcrumbs = {};
    breadcrumbs['item1'] = 'Home';
    breadcrumbs['item2'] = '';
    breadcrumbs['item3'] = '';
    breadcrumbs['item4'] = '';
    breadcrumbs['item5'] = '';
    breadcrumbs['item6'] = '';

    if (breadcrumbholder.length > 0)
    {
        var i = 1;
        breadcrumbholder.each(function ()
        {
            var breadcrumbTitle = $(this).attr('title');
            if (typeof (breadcrumbTitle) !== 'undefined' && breadcrumbTitle != null && breadcrumbTitle != '')
            {
                breadcrumbs['item' + i] = breadcrumbTitle;
                i++;
            }
        });
    }

    return breadcrumbs;
}